import restoreLoadMore from '../utility/restoreLoadMore'

jQuery(document).on('click', '.lay-news-load-more', function () {
	var $newsElement = jQuery(this.parentNode.parentNode).find('.lay-news-element[data-amount]')
	var amt = $newsElement.attr('data-amount')

	var $hidden = $newsElement.find('.hide-news')
	$hidden.each(function (index) {
		if (index < amt) {
			jQuery(this).addClass('show-news').removeClass('hide-news')
		}
	})

	// Save load more state to sessionStorage
	var elementType = restoreLoadMore.getElementType($newsElement)
	var elementId = restoreLoadMore.getElementId($newsElement)
	if (elementType && elementId) {
		var currentShown = $newsElement.find('.show-news').length
		if (restoreLoadMore.isRememberEnabled()) {
			restoreLoadMore.saveLoadMoreState(elementType, elementId, { itemsShown: currentShown })
		} else {
			restoreLoadMore.clearLoadMoreState(elementType, elementId)
		}
	}

	var $hidden2 = $newsElement.find('.hide-news')
	if ($hidden2.length == 0) {
		jQuery(this).hide()
	}
	// this is used to trigger carousel images loading in now shown news, when using "show full content" layout
	window.laytheme.emit('newsLoadMore', $newsElement)
})

// Restore load more state for news elements
var restoreNewsLoadMoreState = function ($target) {
	if (!$target) {
		$target = jQuery('body')
	}
	$target.find('.lay-news-element[data-amount]').each(function () {
		var $newsElement = jQuery(this)
		var elementType = restoreLoadMore.getElementType($newsElement)
		var elementId = restoreLoadMore.getElementId($newsElement)
		if (elementType && elementId) {
			if (!restoreLoadMore.isRememberEnabled()) {
				restoreLoadMore.clearLoadMoreState(elementType, elementId)
				return
			}
			var savedState = restoreLoadMore.getLoadMoreState(elementType, elementId)
			if (savedState && savedState.itemsShown && savedState.itemsShown > 0) {
				var $hidden = $newsElement.find('.hide-news')
				var currentShown = $newsElement.find('.show-news').length
				var itemsToShow = savedState.itemsShown - currentShown
				if (itemsToShow > 0) {
					$hidden.slice(0, itemsToShow).addClass('show-news').removeClass('hide-news')
				}

				// Hide button if all items are shown
				if ($newsElement.find('.hide-news').length === 0) {
					$newsElement.find('.lay-news-load-more').hide()
				}
			}
		}
	})
}

// Restore on page load
jQuery(document).ready(function () {
	restoreNewsLoadMoreState()
})

// Restore on newpageshown (for AJAX navigation)
if (window.laytheme) {
	window.laytheme.on('newpageshown', function () {
		setTimeout(function () {
			restoreNewsLoadMoreState()
		}, 100)
	})
}
